export type Company = {
  id: number
  name: string
}

export type CompanyForSelect = {
  id: number
  text: string
}

export type BreakdownInfo = {
  c: string
  s: number
  seller_name: string
  match_percentage: string
  prisync_index: string
  mine: number
  url: string
}

export enum CompanyStatus {
  TRIAL = 'in_trial',
  PAID = 'paid',
  UNINSTALLED = 'uninstalled',
  EXPIRED = 'expired',
  ADMIN = 'admin',
  DEMO = 'in_demo',
  CHURNED = 'churned',
  TEST = 'test',
  PAYMENT_PROBLEM_PANEL_ENABLED = 'payment_problem_panel_enabled',
  PAYMENT_PROBLEM_PANEL_DISABLED = 'payment_problem_panel_disabled',
}

export const CompanyStatusInfoMessageMap = {
  [CompanyStatus.TRIAL]: {
    title: 'Your app is in trial.',
    message: 'Your app is currently in trial mode.',
  },
  [CompanyStatus.PAID]: {
    title: 'We Need Your Attention.',
    message:
      'It seems that your account is having payment issues. You can contact us by emailing info@prisync.com or leaving a message in the live chat box in the bottom right corner.',
  },
  [CompanyStatus.UNINSTALLED]: {
    title: 'We Need Your Attention.',
    message:
      'Your app is uninstalled. The Shopify integration is disabled at the moment. To re-enable the integration, you can install the Dynamic Pricing Optimization tool from the Shopify app store. If you have any questions or need assistance with the installation process, You can contact us by emailing info@prisync.com or leaving a message in to live chat box on the bottom right corner.',
  },
  [CompanyStatus.EXPIRED]: {
    title: 'We Need Your Attention.',
    message:
      "Your 14-day free trial has ended. Let's explore plans and continue where you left off.",
  },
  [CompanyStatus.ADMIN]: {
    title: 'Admin status.',
    message: 'You have admin privileges.',
  },
  [CompanyStatus.DEMO]: {
    title: 'Your app is in demo mode.',
    message: 'Your app is currently in demo mode.',
  },
  [CompanyStatus.CHURNED]: {
    title: 'Your app subscription has been churned.',
    message:
      'Your subscription has been canceled. Please contact support for further assistance.',
  },
  [CompanyStatus.TEST]: {
    title: 'Your app is in test mode.',
    message: 'Your app is currently in test mode.',
  },
  [CompanyStatus.PAYMENT_PROBLEM_PANEL_ENABLED]: {
    title: 'Payment problem panel is enabled.',
    message: 'The payment problem panel is currently enabled.',
  },
  [CompanyStatus.PAYMENT_PROBLEM_PANEL_DISABLED]: {
    title: 'We need your attention.',
    message:
      'It seems that your account is having payment issues. You can contact us by emailing info@prisync.com or leaving a message in the live chat box in the bottom right corner.',
  },
}

export type ProductLimits = {
  total: number
  remaining: number
}
